import { FC, HTMLAttributes } from 'react'

import { twMerge } from '~/lib/utils'

type PageHeadingProps = HTMLAttributes<HTMLHeadingElement>

export const PageHeading: FC<PageHeadingProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <h1
      className={twMerge(
        'text-[22px] font-bold leading-[140%] md:text-[28px]',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
}
